import { Column, Table } from '@tanstack/react-table';
import { CSSProperties } from 'react';

export function createColumnStyleGetter<T>(table: Table<T>) {
	const columns = table.getAllColumns();

	const totalRatio = columns.reduce((sum, col) => {
		const widthMeta = col.columnDef.meta?.width;
		if (widthMeta && 'ratio' in widthMeta) return sum + widthMeta.ratio;
		return sum;
	}, 0);

	return (column: Column<T>): CSSProperties => {
		const widthMeta = column.columnDef.meta?.width;

		if (widthMeta) {
			if ('fixedPx' in widthMeta) {
				return {
					width: widthMeta.fixedPx,
					minWidth: widthMeta.fixedPx,
					maxWidth: widthMeta.fixedPx,
				};
			}
			// Ideally, ratio-based width should be: calc((ratio/totalRatio) * (100% - totalFixedPx))
			// However, calc() doesn't apply correctly under table-fixed layout
			// So we ignore fixedPx columns and calculate percentage from ratios only
			const percent = (widthMeta.ratio / totalRatio) * 100;
			return {
				width: `${percent}%`,
				minWidth: widthMeta.minPx,
				maxWidth: `${percent}%`,
			};
		}

		const size = column.columnDef.size;
		const minSize = column.columnDef.minSize;
		if (size !== undefined || minSize !== undefined) {
			return {
				...(size !== undefined && { width: size }),
				...(minSize !== undefined && { minWidth: minSize }),
			};
		}

		return {};
	};
}
